import { Component, input, output } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface IconDropdownOption {
  value: string;
  label: string;
  icon?: string;
  imgSrc?: string;
  disabled?: boolean;
}

/**
 * Icon-only trigger that reveals a dropdown of options.
 * Rendered through mat-menu (CDK overlay) so the panel never gets clipped
 * by overflow:hidden/auto ancestors — required for floating action bars.
 */
@Component({
  // cm- prefix matches the sibling cm-icon-button this component composes with
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'cm-icon-dropdown',
  standalone: true,
  imports: [MatIconModule, MatMenuModule, MatTooltipModule],
  templateUrl: './icon-dropdown.component.html',
  styleUrl: './icon-dropdown.component.scss',
})
export class CmIconDropdownComponent {
  readonly icon = input<string>('');
  readonly imgSrc = input<string>('');
  readonly alt = input<string>('');
  readonly options = input<IconDropdownOption[]>([]);
  readonly activeValue = input<string | null>(null);
  readonly disabled = input(false);

  readonly optionSelected = output<string>();
  readonly menuOpened = output<void>();
  readonly menuClosed = output<void>();

  select(option: IconDropdownOption): void {
    if (option.disabled) return;
    this.optionSelected.emit(option.value);
  }
}
